import requestFunctions from "../../functions/requestFunctions";


export const state = {
  MOVINGS_ITEM: {},
  MOVINGS_LIST: [],
  MOVINGS_TABLE_DATA: [],
  MOVINGS_TABLE_PRODUCTS_DATA: [],
  MOVINGS_ARRAY_DATA: [],
  MOVINGS_TOTAL_ROWS: 0
}

export const getters = {
  GET_MOVINGS_ITEM: (state) => {
    return state.MOVINGS_ITEM;
  },
  GET_MOVINGS_LIST: (state) => {
    return state.MOVINGS_LIST;
  },
  GET_MOVINGS_TABLE_DATA: (state) => {
    return state.MOVINGS_TABLE_DATA;
  },
  GET_MOVINGS_TABLE_PRODUCTS_DATA: (state) => {
    return state.MOVINGS_TABLE_PRODUCTS_DATA;
  },
  GET_MOVINGS_ARRAY_DATA: (state) => {
    return state.MOVINGS_ARRAY_DATA;
  },
  GET_MOVINGS_TOTAL_ROWS: (state) => {
    return state.MOVINGS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_MOVINGS_ITEM(state, item) {
    state.MOVINGS_ITEM = item;
  },

  UPDATE_MOVINGS_TABLE_PRODUCTS_DATA(state, list) {

    list = list.data;

    state.MOVINGS_TABLE_PRODUCTS_DATA = [];

    list.forEach(el => {
      state.MOVINGS_TABLE_PRODUCTS_DATA.push({
        'uuid'  : el.uuid,
        'fl_set': el.fl_set,
        'set_product_id': el.set_product_id,        
        'product_name': el.product_name,
        'product_uuid': el.product_uuid,
        'product_id'  : el.product_id,
        'qnt' : el.qnt,
        'cost': el.cost,
        'sum' : el.sum,
        'unit_name' : el.unit_name,
        'unit_code' : el.unit_code,
        'created_at': el.created_at,
        'updated_at': el.updated_at,
      });
    });

  },

  UPDATE_MOVINGS_LIST(state, list) {

    state.MOVINGS_LIST = list.data;

    state.MOVINGS_TOTAL_ROWS = list.total;
    list = list.data;

    state.MOVINGS_TABLE_DATA = [];
    state.MOVINGS_ARRAY_DATA = [];

    list.forEach(el => {

      let status = {
        'draft'  : 'Черновик',
        'closed' : 'Закрыт',
        'check'  : 'Проверить'
      }

      state.MOVINGS_TABLE_DATA.push({
        'uuid' : el.uuid,
        'id'   : el.id,
        'number': el.number,
        'document_date' : el.document_date,
        'company_from_name': el.company_from_name,
        'counterparty_from_name': el.counterparty_from_name,
        'warehouse_from_name': el.warehouse_from_name,
        'company_to_name': el.company_to_name,
        'counterparty_to_name': el.counterparty_to_name,
        'warehouse_to_name': el.warehouse_to_name,
        'sum': el.sum,
        'comments' : el.comments,
        'status': status[el.status] ? status[el.status] : '',
        'created_at' : el.created_at,
        'updated_at' : el.updated_at,
      });

      state.MOVINGS_ARRAY_DATA.push({
        id: el.id,
        uuid: el.uuid,
      });
    });
  },
}

export const actions = {

  async FETCH_MOVINGS_ITEM({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_MOVINGS_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_MOVINGS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_MOVINGS_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_MOVINGS_LIST_PRODUCTS({ commit }, payload= {}) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings/' + payload.uuid + '/products';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_MOVINGS_TABLE_PRODUCTS_DATA', response.data);
      return response.data;
    }
  },

  async FETCH_MOVINGS_CREATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_MOVINGS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_MOVINGS_DELETE({ commit }, payload) {

    let query_url = 'https://api.tradeanalytic.ru/v1/movings/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}